export default __webpack_public_path__ + "assets/images/ff53e1df0fa3eaeb4859b93ba0217289.png";